/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Features_HeadingInputs */

const en_homepage_features_heading = /** @type {(inputs: Homepage_Features_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zip through your reading`)
};

const es_homepage_features_heading = /** @type {(inputs: Homepage_Features_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Acelera tu lectura`)
};

/**
* | output |
* | --- |
* | "Zip through your reading" |
*
* @param {Homepage_Features_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_features_heading = /** @type {((inputs?: Homepage_Features_HeadingInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Features_HeadingInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_features_heading(inputs)
	return en_homepage_features_heading(inputs)
});